import Raven from 'raven-js';
import { Metrics } from 'crm-activity-creator-data/utils/Metrics';
import { CALL, EMAIL, LINKED_IN, LOGGED_CALL, LOGGED_EMAIL, LOGGED_LINKED_IN_MESSAGE, LOGGED_MEETING, LOGGED_POSTAL_MAIL, LOGGED_SMS, LOGGED_WHATS_APP, NOTE, SCHEDULE, TASK, ENROLLED_IN_SEQUENCE, WHATS_APP } from 'crm-activity-creator-data/interaction/InteractionTypes';
import { BUTTON_ERRORS, MISSING_INTERACTION_TYPE } from 'crm-activity-creator-data/constants/errors';
import { CallingIcon } from 'foundations-assets/icons/components/CallingIcon';
import { DescriptionIcon } from 'foundations-assets/icons/components/DescriptionIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { LogCallIcon } from 'foundations-assets/icons/components/LogCallIcon';
import { LogEmailIcon } from 'foundations-assets/icons/components/LogEmailIcon';
import { LogLinkedInMessageIcon } from 'foundations-assets/icons/components/LogLinkedInMessageIcon';
import { LogMeetingIcon } from 'foundations-assets/icons/components/LogMeetingIcon';
import { LogPostalMailIcon } from 'foundations-assets/icons/components/LogPostalMailIcon';
import { LogSMSIcon } from 'foundations-assets/icons/components/LogSMSIcon';
import { LogWhatsAppMessageIcon } from 'foundations-assets/icons/components/LogWhatsAppMessageIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { QuestionIcon } from 'foundations-assets/icons/components/QuestionIcon';
import { SequencesIcon } from 'foundations-assets/icons/components/SequencesIcon';
import { SocialBlockLinkedinIcon } from 'foundations-assets/icons/components/SocialBlockLinkedinIcon';
import { SocialWhatsappIcon } from 'foundations-assets/icons/components/SocialWhatsappIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
export const getButtonIconName = interactionName => {
  if (!interactionName) {
    Raven.captureMessage('Missing interaction name for button icon', {
      fingerprint: ['ERROR_BUTTON_ICON_MISSING_TYPE'],
      extra: {
        interactionName
      }
    });
  }
  switch (interactionName) {
    case CALL:
      return 'calling';
    case EMAIL:
      return 'email';
    case LINKED_IN:
      return 'socialBlockLinkedin';
    case LOGGED_CALL:
      return 'logCall';
    case LOGGED_EMAIL:
      return 'logEmail';
    case LOGGED_LINKED_IN_MESSAGE:
      return 'logLinkedInMessage';
    case LOGGED_MEETING:
      return 'logMeeting';
    case LOGGED_POSTAL_MAIL:
      return 'logPostalMail';
    case LOGGED_SMS:
      return 'logSMS';
    case LOGGED_WHATS_APP:
      return 'logWhatsAppMessage';
    case NOTE:
      return 'description';
    case SCHEDULE:
      return 'meetings';
    case TASK:
      return 'tasks';
    case ENROLLED_IN_SEQUENCE:
      return 'sequences';
    case WHATS_APP:
      return 'socialWhatsapp';
    default:
      Metrics.counter(BUTTON_ERRORS, {
        interaction_type: interactionName || MISSING_INTERACTION_TYPE
      }).increment();
      Raven.captureMessage('Unknown interaction type received when determining Activity Creator button icon.', {
        fingerprint: ['ERROR_BUTTON_ICON_UNKNOWN_TYPE'],
        extra: {
          interactionName
        }
      });
      return 'question';
  }
};
export const getButtonIcon = interactionName => {
  if (!interactionName) {
    Raven.captureMessage('Missing interaction name for button icon', {
      fingerprint: ['ERROR_BUTTON_ICON_MISSING_TYPE'],
      extra: {
        interactionName
      }
    });
  }
  switch (interactionName) {
    case CALL:
      return CallingIcon;
    case EMAIL:
      return EmailIcon;
    case LINKED_IN:
      return SocialBlockLinkedinIcon;
    case LOGGED_CALL:
      return LogCallIcon;
    case LOGGED_EMAIL:
      return LogEmailIcon;
    case LOGGED_LINKED_IN_MESSAGE:
      return LogLinkedInMessageIcon;
    case LOGGED_MEETING:
      return LogMeetingIcon;
    case LOGGED_POSTAL_MAIL:
      return LogPostalMailIcon;
    case LOGGED_SMS:
      return LogSMSIcon;
    case LOGGED_WHATS_APP:
      return LogWhatsAppMessageIcon;
    case NOTE:
      return DescriptionIcon;
    case SCHEDULE:
      return MeetingsIcon;
    case TASK:
      return TasksIcon;
    case ENROLLED_IN_SEQUENCE:
      return SequencesIcon;
    case WHATS_APP:
      return SocialWhatsappIcon;
    default:
      Metrics.counter(BUTTON_ERRORS, {
        interaction_type: interactionName || MISSING_INTERACTION_TYPE
      }).increment();
      Raven.captureMessage('Unknown interaction type received when determining Activity Creator button icon.', {
        fingerprint: ['ERROR_BUTTON_ICON_UNKNOWN_TYPE'],
        extra: {
          interactionName
        }
      });
      return QuestionIcon;
  }
};